import { LocalDate } from '@js-joda/core';

import { Range } from '@dreryk/watermelon';

import { DEFAULT_INSURANCE_TYPE } from '../common/common.constants';
import { getTodayDate } from '../common/common.utils';

import { GuardianMedicalLeaveFormBean } from './guardianMedicalLeave.types';

export const getGuardianMedicalLeaveFormInitialValues = (): GuardianMedicalLeaveFormBean => ({
   insuranceType: DEFAULT_INSURANCE_TYPE,
   reason: null,
   payers: [],
   leaveAfterTerminationOfEmployment: {},
   leaveDateRange: Range.closed<LocalDate>(getTodayDate(), getTodayDate()),
   address: null,
   guardian: null,
   relationCode: 'CHILD' as const,
   birthDate: null,
});
